import { Controller } from "@hotwired/stimulus";

// Copies the text of the `source` target and briefly swaps the button's label or icon.
// Kept generic so any snippet elsewhere (docs, settings, overview) can reuse it.
export default class extends Controller {
  static targets = ["source", "button", "defaultIcon", "successIcon"];
  static values = {
    copiedLabel: { type: String, default: "Copied" },
  };

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  async copy() {
    const text = this.sourceTarget.textContent.trim();

    try {
      await navigator.clipboard.writeText(text);
    } catch {
      // Clipboard permission can be denied, and the API is absent on insecure
      // origins. A silent no-op beats an exception the user cannot act on.
      return;
    }

    this.#confirm();
  }

  #confirm() {
    if (this.hasDefaultIconTarget && this.hasSuccessIconTarget) {
      this.defaultIconTarget.classList.add("hidden");
      this.successIconTarget.classList.remove("hidden");
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.defaultIconTarget.classList.remove("hidden");
        this.successIconTarget.classList.add("hidden");
      }, 2000);
      return;
    }

    if (!this.hasButtonTarget) return;

    if (this.originalLabel === undefined) {
      this.originalLabel = this.buttonTarget.textContent;
    }

    this.buttonTarget.textContent = this.copiedLabelValue;
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.buttonTarget.textContent = this.originalLabel;
    }, 2000);
  }
}
